module.exports = {
    tag: 'sloth',
    quality: 0,
    speed: -1.0
};